const BASIC: "basic" = "basic"
const ELECTRIC: "electric" = "electric"
const HOLIDAY_RATE: "holiday_rate" = "holiday_rate"
const WEEKEND_RATE: "weekend_rate" = "weekend_rate"
const ADDITIONAL_ADULTS: "additional_adults" = "additional_adults"
const ADDITIONAL_KIDS: "additional_kids" = "additional_kids"
const ADDITIONAL_PETS: "additional_pets" = "additional_pets"
const CUSTOM: "custom" = "custom"
const DEPOSIT: "deposit" = "deposit"
const PARTIAL_PAYMENT: "partial_payment" = "partial_payment"

const LINE_ITEM_KINDS = {
  BASIC,
  ELECTRIC,
  HOLIDAY_RATE,
  WEEKEND_RATE,
  ADDITIONAL_ADULTS,
  ADDITIONAL_KIDS,
  ADDITIONAL_PETS,
  CUSTOM,
  DEPOSIT,
  PARTIAL_PAYMENT,
}

type lineItemKind =
  | typeof BASIC
  | typeof ELECTRIC
  | typeof HOLIDAY_RATE
  | typeof WEEKEND_RATE
  | typeof ADDITIONAL_ADULTS
  | typeof ADDITIONAL_KIDS
  | typeof ADDITIONAL_PETS
  | typeof CUSTOM
  | typeof DEPOSIT
  | typeof PARTIAL_PAYMENT

export { LINE_ITEM_KINDS }
export type { lineItemKind }
